import React from "react";
import {
  PlatformDomainObjectType,
  PlatformPermission,
} from "@chemaxon/terminus-client/ui/models/Permission";
import { usePermissions } from "@chemaxon/terminus-client/ui/utils/usePermissions";

type RestrictedProps = {
  children?: React.ReactNode;
  to: {
    platformDomainObjectType: PlatformDomainObjectType;
    platformPermission: PlatformPermission;
  };
};

export const Restricted = ({
  children,
  to: { platformDomainObjectType, platformPermission },
}: RestrictedProps) => {
  const { checkPermission } = usePermissions();

  if (checkPermission(platformDomainObjectType, platformPermission)) {
    return children;
  }

  return null;
};

export const OnlyForTeamAdmin = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { isUserTeamAdmin } = usePermissions();

  return isUserTeamAdmin ? children : null;
};
